/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	CampaignAvailabilityCheckShowPathParams,
	CampaignAvailabilityCheckShowResponse,
} from '../types/CampaignAvailabilityCheckShow'

/**
 * GET /interview-scheduling/campaigns/:campaign/availability-check
 * @see backend/nexus/modules/InterviewScheduling/Http/Controllers/CampaignAvailabilityCheckController.php CampaignAvailabilityCheckController::show
 */
export async function campaignAvailabilityCheckShow(
	campaign: CampaignAvailabilityCheckShowPathParams['campaign'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CampaignAvailabilityCheckShowResponse>> {
	return axiosInstance.get(`/interview-scheduling/campaigns/${campaign}/availability-check`, config)
}
